var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5750_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11.75C18.8734 11.7493 19.7349 11.9524 20.516 12.343C21.2972 12.7335 21.9765 13.3009 22.5 14",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14C2.0235 13.3009 2.70281 12.7335 3.48398 12.343C4.26514 11.9524 5.12663 11.7493 6 11.75",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C14.0711 17.75 15.75 16.0711 15.75 14C15.75 11.9289 14.0711 10.25 12 10.25C9.92893 10.25 8.25 11.9289 8.25 14C8.25 16.0711 9.92893 17.75 12 17.75Z",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 20.75C7.2884 19.8364 8.0559 19.079 8.97665 18.5529C9.8974 18.0267 10.9395 17.75 12 17.75C13.0605 17.75 14.1026 18.0267 15.0233 18.5529C15.9441 19.079 16.7116 19.8364 17.25 20.75",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 8C15.234 7.45678 15.5238 6.96377 15.9302 6.57697C16.3366 6.19017 16.8433 5.92508 17.3927 5.81179C17.9422 5.69851 18.5125 5.74158 19.0387 5.93611C19.5649 6.13064 20.0261 6.46883 20.3697 6.91229C20.7134 7.35574 20.9258 7.88668 20.9829 8.4448C21.04 9.00293 20.9394 9.56587 20.6926 10.0697C20.4458 10.5735 20.0627 10.9981 19.5867 11.2951C19.1108 11.5921 18.561 11.7497 18 11.75",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99995 11.75C5.43892 11.7497 4.8892 11.5921 4.41324 11.2951C3.93727 10.9981 3.55413 10.5735 3.30733 10.0697C3.06053 9.56587 2.95996 9.00293 3.01703 8.4448C3.07411 7.88668 3.28655 7.35574 3.63022 6.91229C3.9739 6.46883 4.43504 6.13064 4.96127 5.93611C5.4875 5.74158 6.05774 5.69851 6.60722 5.81179C7.1567 5.92508 7.6634 6.19017 8.06979 6.57697C8.47617 6.96377 8.76594 7.45678 8.9062 8",
    stroke: "#CA8A04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5750_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.bfda049cd01dd7e8cc9d3bb46721b705.svg";
export { ForwardRef as ReactComponent };